import VueApollo from 'vue-apollo';
import { apolloClient } from '@/modules/MbtiGraphQL';
import { apolloClient as myStageApolloClient} from '@/modules/myStageGraphQL';

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  clients: {
    mbti:apolloClient,
    // mystage-backend
    msb: myStageApolloClient,
  }
});

export {
  apolloProvider
};
